import React from "react";
import * as Mui from "@mui/material";
import { SettingsDialog } from "component/shared/settings-dialog";

interface Props {
	open: boolean;
	email: string;
	onClose: () => void;
	onConfirm: () => void;
}

export const DeleteRecipientDialog: React.FC<Props> = ({ open, email, onClose, onConfirm }) => (
	<SettingsDialog
		open={open}
		title="Delete recipient?"
		onClose={onClose}
		confirmLabel="Remove Recipient"
		onConfirm={onConfirm}
	>
		<Mui.Typography>
			Removing "{email}" will delete this address as an option from all lead activity
			notification dropdowns and remove any existing assignments.
		</Mui.Typography>
	</SettingsDialog>
);
